/* eslint-disable */
import { useState, useEffect } from 'react'
import { Text, useGLTF } from '@react-three/drei'
import * as THREE from 'three'
import BillboardHoarding from '../BillboardHoarding'
import PropTypes from 'prop-types'
import { useBox } from '@react-three/cannon'
import { useModelTransition } from '../../hooks'

const LaprasInLake = ({ page }) => {
  const gltf = useGLTF('./libs/lapras_in_lake/scene.gltf')
  const model = {
    blendDuration: 0.4,
    position: new THREE.Vector3(10, 0, 5),
    rotation: new THREE.Vector3(0, -Math.PI, 0),
    options: {
      focusOnPosition: new THREE.Vector3(10, 2, 2),
      animateToPosition: new THREE.Vector3(5, 2, -7),
      fov: 30,
    },
  }
  const [isActive, setIsActive] = useState(false)
  const [activateMesh] = useBox(() => ({
    args: [8, 8, 0.05],
    rotation: [-Math.PI / 2, 0, 0],
    position: [model.position.x, 0.001, model.position.z],
  }))
  useEffect(
    () => (page === 'experience' ? setIsActive(true) : setIsActive(false)),
    [page]
  )
  useModelTransition(isActive, model.options)

  useEffect(() => {
    activateMesh.current.name = 'activitymesh.experience'
  }, [])

  return (
    <mesh>
      <primitive
        rotation={[...model.rotation]}
        position={[...model.position]}
        scale={1}
        object={gltf.scene}
        dispose={null}
      />
      <Text
        color="#212121"
        position={[model.position.x + 2, 1.5, model.position.z - 2.2]}
        fontSize={0.2}
        letterSpacing={0.2}
        fillOpacity={0}
        outlineColor="#212121"
        outlineWidth={0.01}
        rotation={[...model.rotation]}
      >
        Experience
      </Text>
      <BillboardHoarding
        position={[model.position.x + 2, 0, model.position.z - 2]}
        scale={0.2}
        rotation={[...model.rotation]}
      />
      <mesh ref={activateMesh} />
    </mesh>
  )
}
LaprasInLake.defaultProps = {
  page: '',
}

LaprasInLake.propTypes = {
  page: PropTypes.string,
}
useGLTF.preload('./libs/lapras_in_lake/scene.gltf')

export default LaprasInLake
